import { Box } from '@breathelife/mui';
import styled from '../../../../Styles/themed-styled-components';

export const UserEditContainer = styled.div`
  display: flex;
  align-items: stretch;
  padding: 10px 0;

  @media (max-width: ${(props) => props.theme.moduleBreakpoints.md}) {
    flex-direction: column;
  }
`;

export const ProfilePreferencesContainer = styled(Box)`
  border-left: 1px solid ${(props) => props.theme.colors.grey[30]};

  @media (max-width: ${(props) => props.theme.moduleBreakpoints.md}) {
    margin: 30px 0 0 0 !important;
    padding: 0 !important;
    border-left: none;
  }
`;
